import './styles.scss';
import PageFooter from '../Footer/Footer';
import HomeHeader from '../HomeHeader/HomeHeader';

export default function NoGroupPage() {
  return (
    <>
      <HomeHeader />
      <div className="no-group-wrapper">
        <div className="no-group-warning">
          <h1>Contact the SPI team for access</h1>
          <a href="mailto:england.invitationservicessupport@nhs.net">england.invitationservicessupport@nhs.net</a>
          <p>Log out to return to the SPI homepage</p>
        </div>
      </div>
      <PageFooter />
    </>
  );
}
